import React, { useState, useRef, useMemo, useEffect } from "react";
import { Flex, List, Divider, Typography, Modal } from "antd";
import CustomAvatar from "../../../Components/CustomAvatar";
import { LockIcon } from "../../../assets/icons";
import { debounce } from "lodash";
import { useNavigate } from "react-router";
import ApiService from "../../../API/apiService";
import { API_ENDPOINTS } from "../../../API/endpoints";
import { useBridgeStore } from "../../../store/apis/useBridgeStore";

const { Text } = Typography;

const FindChannelModal = ({ open, onCancel, channelList, chatList }) => {
  const triggerSidebarRefresh = useBridgeStore(
    (state) => state.triggerSidebarRefresh
  );
  const UserData = JSON.parse(localStorage.getItem("userData"));
  const [searchChannelTerm, setSearchChannelTerm] = useState("");
  const [hoverState, setHoverState] = useState("");
  const [isFindChannelModalOpen, setIsFindChannelModalOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  let rout=UserData?.domain || 'elsnertech'


  const [searchChannelList, setSearchChannelList] = useState({
    usersList: [],
    channelsList: []
  });
  useEffect(() => {
    if (open) {
      setSearchChannelList({
        usersList: chatList || [],
        channelsList: channelList || []
      });
      setSearchChannelTerm("");
      searchChannelApi(searchChannelTerm)
    }
  }, [open]);

  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const searchChannelApi = async (searchTerm) => {
    setLoading(true);
    try { 
      const body = {
        searchTerm,
        userId: UserData?._id
      };
      const response = await ApiService.post(
        API_ENDPOINTS.browseChannel,
        body
      );
      if (response?.data && response?.statusCode === 200) {
        const { users, channels } = response.data;
        setHoverState(users.length > 0 ? users[0]?._id : channels.length > 0 ? channels[0]?._id : "");
        setSearchChannelList({ usersList: users || [], channelsList: channels || [] });
      } else {
        setSearchChannelList({ usersList: [], channelsList: [] });
      }
    } catch (error) {
      setSearchChannelList({ usersList: [], channelsList: [] });
    } finally {
      setLoading(false);
    }
  };

  const debouncedSearchChannelApi = useMemo(() => {
    return debounce((value) => {
      searchChannelApi(value);
      if (value.length === 0) {
        searchChannelApi("");
      }
    }, 600);
  }, []);

  const getChannelByIdApi = async (id) => {
    localStorage.setItem("current_id", id);
    // navigate(`/elsnertech/channels/${id}`);
    navigate(`/${rout}/channels/${id}`);

  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchChannelTerm(value);
    debouncedSearchChannelApi(value);
  };

  const handleUserClick = async(item) => {
    localStorage.setItem("previous_id", localStorage.getItem("current_id") || "");
    localStorage.setItem("current_id", item?._id);
    setIsFindChannelModalOpen(false);
    setSearchChannelTerm("");
    let response  = await ApiService.post(API_ENDPOINTS.addUserInChatList, {
      userId: UserData._id,
      selectedUserId: item?._id,
    });
    if (response.status === 1) {
      triggerSidebarRefresh(Date.now());
    }
    navigate(`/${rout}/message/${item?._id}`);
    handleCancel()
  };

  const handleChannelClick = (item) => {
    getChannelByIdApi(item?._id);
    setDropdown(false);
    localStorage.setItem("previous_id", localStorage.getItem("current_id") || "");
    localStorage.setItem("current_id", item?._id);
    setIsFindChannelModalOpen(false);
    setSearchChannelTerm("");
    handleCancel()
  };

  const handleCancel = () => {
    onCancel();
    setSearchChannelTerm("");
  };

  return (
    <Modal
      destroyOnClose
      title="Start Chat"
      open={open}
      onCancel={handleCancel}
      footer={null}
      className="find-channel-modal"
      width={600}
      style={{ top: 20 }}
    >
      <Flex vertical className="ant-modal-subheader">
        <div className="search-container">
          <i className="fa-solid fa-magnifying-glass search-icon"></i>
          <input
            value={searchChannelTerm}
            onChange={handleSearchChange}
            type="text"
            className="custom-search"
            placeholder="Search"
            ref={inputRef}
          />
        </div>
      </Flex>
      <Divider />
      <Flex vertical className="suggestion-list-container ">
        <Text type="secondary" className="title">
          Users
        </Text>
        <List
          className="suggestion-list-users"
          itemLayout="horizontal"
          dataSource={searchChannelList.usersList}
          renderItem={(item) => (
            <List.Item
              onMouseEnter={() => setHoverState(item?._id)}
              className={hoverState == item?._id ? "hoverClass" : ""}
              onClick={() => handleUserClick(item)}
            >
              <List.Item.Meta
                avatar={<CustomAvatar img={item?.thumbnailAvatarUrl} size={24} userName={item?.fullName} />}
                title={item.fullName}
              />
            </List.Item>
          )}
        />
      </Flex>
      <Divider />
      <Flex vertical className="suggestion-list-container">
        <Text type="secondary" className="title">
          Channels
        </Text>
        <List
          className="suggestion-list-users"
          itemLayout="horizontal"
          dataSource={searchChannelList.channelsList}
          renderItem={(item) => (
            <List.Item
              onMouseEnter={() => setHoverState(item?._id)}
              className={hoverState == item?._id ? "hoverClass" : ""}
              onClick={() => handleChannelClick(item)}
            >
              <List.Item.Meta
                avatar={item?.isPrivate ? <LockIcon /> : <i className="fa-solid fa-globe"></i>}
                title={item.name}
              />
            </List.Item>
          )}
        />
      </Flex>
    </Modal>
  );
};

export default FindChannelModal;